export default "__VITE_ASSET__BNCeDoz6__"